import React, { useEffect } from 'react';

const fmt = v => Number(v || 0).toFixed(2).replace('.', ',');

const TEXTO = {
  enviando:   { icone: '📡', cor: '#1d4ed8', titulo: 'Enviando para a maquininha...' },
  pendente:   { icone: '💳', cor: '#1d4ed8', titulo: 'Aguardando o cliente na maquininha', sub: 'Aproxime, insira ou passe o cartão na maquininha.' },
  cancelando: { icone: '⏳', cor: '#b45309', titulo: 'Cancelando na maquininha...' },
  aprovado:   { icone: '✅', cor: '#15803d', titulo: 'Pagamento aprovado' },
  recusado:   { icone: '❌', cor: '#b91c1c', titulo: 'Pagamento recusado' },
  cancelado:  { icone: '🚫', cor: '#6b7280', titulo: 'Cobrança cancelada' },
  expirado:   { icone: '⌛', cor: '#6b7280', titulo: 'Tempo esgotado — o cliente não pagou' },
  estornado:  { icone: '↩', cor: '#6b7280', titulo: 'Cobrança estornada' },
  erro:       { icone: '⚠', cor: '#b91c1c', titulo: 'Não foi possível cobrar' },
};

/**
 * Tela "aguardando maquininha" do PDV (Mercado Pago Point integrada).
 * Esc: cancela enquanto espera / fecha depois de terminar. Enter: tenta de
 * novo quando recusou/expirou/deu erro.
 */
export default function ModalCobrancaPoint({ cobranca, onCancelar, onFechar, onTentarDeNovo }) {
  const st = cobranca?.status;
  const final = ['recusado', 'cancelado', 'expirado', 'estornado', 'erro'].includes(st);

  useEffect(() => {
    if (!cobranca) return;
    const h = e => {
      if (e.key === 'Escape') {
        e.preventDefault(); e.stopPropagation();
        if (st === 'pendente') onCancelar();
        else if (final) onFechar();
      } else if (e.key === 'Enter' && final) {
        e.preventDefault(); e.stopPropagation();
        onTentarDeNovo();
      } else if (e.key !== 'Tab') {
        e.stopPropagation(); // nenhum atalho do PDV por baixo
      }
    };
    document.addEventListener('keydown', h, true);
    return () => document.removeEventListener('keydown', h, true);
  }, [cobranca, st, final, onCancelar, onFechar, onTentarDeNovo]);

  if (!cobranca) return null;
  const t = TEXTO[st] || TEXTO.pendente;
  const desc = cobranca.tipo === 'debito' ? 'Débito' : `Crédito ${cobranca.parcelas || 1}x`;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 3000,
      display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 10, width: 'min(420px, calc(100vw - 32px))',
        padding: '22px 24px', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,.35)', color: '#111' }}>
        <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 4 }}>
          Maquininha Mercado Pago{cobranca.terminal_nome ? ` — ${cobranca.terminal_nome}` : ''}
        </div>
        <div style={{ fontSize: 30, fontWeight: 800, margin: '4px 0' }}>R$ {fmt(cobranca.valor)}</div>
        <div style={{ fontSize: 13, color: '#374151', marginBottom: 14 }}>{desc}</div>

        <div style={{ fontSize: 38, lineHeight: 1 }} aria-hidden>{t.icone}</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: t.cor, marginTop: 8 }}>{t.titulo}</div>
        {t.sub && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>{t.sub}</div>}
        {st === 'aprovado' && (cobranca.bandeira || cobranca.ultimos_digitos) && (
          <div style={{ fontSize: 12, color: '#374151', marginTop: 4 }}>
            {[cobranca.bandeira, cobranca.ultimos_digitos && `****${cobranca.ultimos_digitos}`].filter(Boolean).join(' ')}
            {cobranca.codigo_autorizacao && ` · Aut. ${cobranca.codigo_autorizacao}`}
          </div>
        )}
        {(cobranca.erro || (st === 'recusado' && cobranca.status_detail)) && (
          <div style={{ fontSize: 12, color: '#b91c1c', marginTop: 8 }}>{cobranca.erro || cobranca.status_detail}</div>
        )}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 18 }}>
          {st === 'pendente' && (
            <button onClick={onCancelar}
              style={{ padding: '8px 16px', border: '1px solid #b91c1c', color: '#b91c1c', background: '#fff', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
              Cancelar cobrança (Esc)
            </button>
          )}
          {final && (
            <>
              <button onClick={onTentarDeNovo}
                style={{ padding: '8px 16px', border: 'none', color: '#fff', background: '#1d4ed8', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
                Tentar de novo (Enter)
              </button>
              <button onClick={onFechar}
                style={{ padding: '8px 16px', border: '1px solid #9ca3af', color: '#374151', background: '#fff', borderRadius: 6, cursor: 'pointer' }}>
                Fechar (Esc)
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
